export const enum Unicode {
  NonbreakingSpace = '\u00A0',
  EmDash = '\u2014',
}
